import React from 'react'
import { Col, Row } from 'reactstrap'
import VideoPlayer from '../../../../components/Common/VideoPlayer'
import styles from './index.module.scss'
import classNames from 'classnames'

function VideoPreview({
  video,
  className
}) {
  return (
    <Row>
          <Col>
            {video && (
              <VideoPlayer
                videoId={video.id}
                videoSrc={video.link}
                poster={video.thumbnailImage?.link || video.videoPreview}
                className={classNames(styles.video, className)}
                tracks={video.translatedVideos}
                />
              )}
          </Col>
      </Row>
  )
}

export default VideoPreview